import React, { Component, useState, useEffect, useContext } from "react";
import { hot } from "react-hot-loader";
import * as tc from "../../services/tc";
import { TreeSelect, Spin, Modal, notification } from "antd";
import { connect } from "dva";
import { SuitesApi } from "../../services/generated-sdk";
const _ = require("lodash");
import { generateTree, handleError } from "../../utils/common";
import { AddSuiteForm } from "../suites/AddSuite";
import { hasPermission } from "../Roles/common";
import { AppContext } from "../../AppContext";

function TestSuiteInputStatic({
  projectId,
  onChange,
  match,
  defaultSuite,
  addNew = false,
  disabled = false,
  showArrow = true,
  ...props
}) {
  const [suites, setSuites] = useState([]);
  const [tree, setTree] = useState([]);
  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState(false);
  const [formLoading, setformLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const { loggedInUser } = useContext(AppContext);
  const canAddSuite = hasPermission(loggedInUser, "suiteAdd");
  var addKeys = items => {
    _.forEach(items, function(item) {
      item.key = "suite_" + item.id.toString();
      item.label = item.title.toString();
      item.value = item.id.toString();
      //prepare suites for SelectTree
      if (item.type == "Suite") {
      } else {
        item.disabled = true;
      }
      if (item.children) {
        addKeys(item.children);
      }
    });
  };

  useEffect(
    () => {
      fetchSuites();
      if (defaultSuite) {
        setValue(defaultSuite);
      }
    },
    [projectId]
  );

  const formatChild = childs => {
    if (childs) {
      return childs.map(child => {
        const data = {
          key: `suite-child-${child.id}`,
          value: child.id,
          title: child["title"],
          isReference: child.isReference,
          isMainLink: child.isMainLink,
          disabled:
            child.isReference && props.enableReference !== true ? true : false
        };
        if (child["children"] && child["children"].length) {
          data["children"] = formatChild(child["children"]);
        }
        return data;
      });
    }
  };

  const searchAndAdd = (childs, data) => {
    childs.some(child => {
      if (child && child.id === data.parentId) {
        if (Array.isArray(child.children)) {
          child.children.push(data);
        } else {
          child.children = [data];
        }
        return true;
      } else {
        if (Array.isArray(child.children)) {
          searchAndAdd(child.children, data);
        }
      }
    });
  };

  const onSelectNode = nodeValue => {
    if (nodeValue === 0) {
      openSuiteModal();
      return;
    }
    setValue(nodeValue);
    onChange(nodeValue);
    return;
  };

  const fetchSuites = async (callback = false) => {
    setLoading(true);
    const suitesApi = new SuitesApi();

    try {
      const suites = await suitesApi.getProjectSuitesTree({
        project: projectId
      });
      // const tree = generateTree(suites);
      const formattedSuite = formatChild(
        suites && suites.length && suites[0].tree ? suites[0].tree : []
      );
      setTree(suites && suites.length && suites[0].tree ? suites[0].tree : []);
      if (addNew && canAddSuite) {
        formattedSuite.push({
          key: `suite-child-0`,
          value: 0,
          title: (
            <a
              onclikc={openSuiteModal}
              style={{ fontWeight: "bold" }}
              className="add_suite"
            >
              {" "}
              Add New Suite
            </a>
          )
        });
      }
      setSuites(formattedSuite);
      setLoading(false);
      if (callback) callback(true);
      // setSuites(suites[0].tree);
      return;
    } catch (e) {
      if (callback) callback(false);
      setLoading(false);
      if (addNew) {
        setSuites([
          {
            key: `suite-child-0`,
            value: 0,
            title: (
              <a onclikc={openSuiteModal} style={{}}>
                {" "}
                Add Suite
              </a>
            )
          }
        ]);
        return;
      }
      setSuites(false);
      handleError(e.status);
    }
  };

  const openSuiteModal = () => {
    setShowForm(true);
  };

  if (!projectId) {
    return <span>Project ID not set!</span>;
  }

  if (suites === false && addNew === false) {
    //return <span>No suites to load!</span>;
    return (
      <div>
        <TreeSelect
          showSearch
          style={{
            width: 240
          }}
          value={value === false ? defaultSuite : value}
          placeholder={"Select Suite"}
          allowClear={true}
          treeData={[]}
          treeDefaultExpandAll={false}
          onChange={onSelectNode}
          filterTreeNode={(string, treeNode) => {
            return treeNode &&
              treeNode.props &&
              treeNode.props.value != "0" &&
              treeNode.props.title &&
              treeNode.props.title.toLowerCase().includes(string.toLowerCase())
              ? true
              : false;
          }}
          disabled={disabled}
          showArrow={showArrow}
          getPopupContainer={trigger => trigger.parentNode}
          {...props}
        />
      </div>
    );
  }

  if (loading) {
    return <Spin delay={1000} />;
  }

  const addSuite = async (form, callback) => {
    setformLoading(true);

    const API = new SuitesApi();
    try {
      const data = await API.addSuite({
        addSuitePayload: {
          title: form.title,
          parentId: form.suite_id != undefined ? form.suite_id : null,
          description: form.description != undefined ? form.description : "",
          project: projectId
        }
      });
      setformLoading(false);
      if (data && data.id && data.title == form.title.trim()) {
        notification["success"]({
          message: "Suite added!",
          description:
            form.addAnother != undefined
              ? "Form has been reset. Now you can add another suite"
              : ""
        });
        if (data.parentId) {
          searchAndAdd(tree, data);
          //console.log({ tree });
        } else {
          tree.push(data);
        }
        const formatted = formatChild(tree);
        if (addNew) {
          formatted.push({
            key: `suite-child-0`,
            value: 0,
            title: <a onclikc={openSuiteModal}>Add Suite</a>
          });
        }
        setSuites(formatted);
        setTimeout(() => {
          onChange(data.id);
          setValue(data.id);
        }, 500);

        setShowForm(false);

        return;
      } else {
        console.info("Failed to add suite");
        notification["error"]({
          message: "Error",
          description: data && data.title ? data.title : "Failed to add suite"
        });
      }
    } catch (e) {
      console.log({ e });
      if (e.json) {
        e.json().then(data => {
          handleError(data.statusCode, {}, data.message || "");
        });
      }
    }
    setformLoading(false);
  };
  //console.log({ suites });
  return (
    <div>
      <TreeSelect
        showSearch
        //name="suite_id"

        style={{
          width: 240
        }}
        value={value === false ? defaultSuite : value}
        placeholder={"Select Suite"}
        allowClear={true}
        treeData={suites}
        treeDefaultExpandAll={false}
        onChange={onSelectNode}
        filterTreeNode={(string, treeNode) => {
          return treeNode &&
            treeNode.props &&
            treeNode.props.value != "0" &&
            treeNode.props.title &&
            treeNode.props.title.toLowerCase().includes(string.toLowerCase())
            ? true
            : false;
        }}
        disabled={disabled}
        showArrow={showArrow}
        {...props}
      />
      <Modal
        visible={showForm}
        footer={null}
        onCancel={() => setShowForm(false)}
        title="Add Suite"
        destroyOnClose
      >
        <AddSuiteForm
          formLoading={formLoading}
          addSuite={addSuite}
          hideAnother={true}
          projectId={projectId}
          history={history}
          isModal={true}
          showCancel={false}
        />
      </Modal>
    </div>
  );
}
function mapStateToProps(state, ownProps) {
  return {};
}

const TestSuiteInput = connect(mapStateToProps)(TestSuiteInputStatic);

export default hot(module)(TestSuiteInput);
